import { last } from 'lodash';

export default function filterSegmentsByFrom(segments, selectedSegmentIds) {
  if (selectedSegmentIds.length === 0) return segments;

  const lastSelectedSegment = segments.find(segment => segment.id === last(selectedSegmentIds));

  return segments.filter(segment => segment.from.id === lastSelectedSegment.to.id);
}



// WEBPACK FOOTER //
// ./src/helpers/filterSegmentsByFrom.js